import { render, staticRenderFns } from "./toolbar-user-menu.vue?vue&type=template&id=4c2b2c6d&scoped=true"
import script from "./toolbar-user-menu.component.ts?vue&type=script&lang=ts&external"
export * from "./toolbar-user-menu.component.ts?vue&type=script&lang=ts&external"
import style0 from "./toolbar-user-menu.vue?vue&type=style&index=0&id=4c2b2c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b2c6d",
  null
  
)

export default component.exports